import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faFolderOpen, faHashtag, faSave, faTimes, faUpload } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        ano_oymri: '',
        mes_oymri: '',
        files: '',
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    cambioValorFiles = (e) => {
        this.setState({ files: e.target.files });
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { ano_oymri, mes_oymri, files } = this.state;
        var errores = [];
        if (!ano_oymri) { errores.push("error_ano_oymri"); }
        if (!mes_oymri) { errores.push("error_mes_oymri"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        for (let i = 0; i < files.length; i++) {
            formData.append(files[i].name, files[i])
        }
        Swal.showLoading();
        authAxios.post("archivos_oymri/cargar_oymri", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Pagos Operador!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/AddCargueOYMRI");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Pagos Operador!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    render() {
        const { ano_oymri, mes_oymri } = this.state
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>CARGUE PAGOS OPERADOR</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id='form'>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="ano_oymri">Año</label>
                                                    <select name="ano_oymri"
                                                        id="ano_oymri"
                                                        className={((this.verificarError("error_ano_oymri")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="0">Seleccione el Año</option>
                                                        <option value="2022">2022</option>
                                                        <option value="2023">2023</option>
                                                        <option value="2024">2024</option>
                                                        <option value="2025">2025</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Año</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="mes_oymri">Mes</label>
                                                    <select name="mes_oymri"
                                                        id="mes_oymri"
                                                        className={((this.verificarError("error_mes_oymri")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="0">Seleccione el Mes</option>
                                                        <option value="Enero">ENERO</option>
                                                        <option value="Febrero">FEBRERO</option>
                                                        <option value="Marzo">MARZO</option>
                                                        <option value="Abril">ABRIL</option>
                                                        <option value="Mayo">MAYO</option>
                                                        <option value="Junio">JUNIO</option>
                                                        <option value="Julio">JULIO</option>
                                                        <option value="Agosto">AGOSTO</option>
                                                        <option value="Septiembre">SEPTIEMBRE</option>
                                                        <option value="Octubre">OCTUBRE</option>
                                                        <option value="Noviembre">NOVIEMBRE</option>
                                                        <option value="Diciembre">DICIEMBRE</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Año</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-4'>
                                                    <label htmlFor="files">Archivos OYM - RI</label>
                                                    <div className='input-group input-group-sm mb-3'>
                                                        <label className="input-group-text label_files" htmlFor="files"><FontAwesomeIcon icon={faFolderOpen} />&nbsp;&nbsp;Seleccionar Archivo(s) </label>
                                                        <input className="form-control form-control-sm" type="file" id="files" multiple onChange={this.cambioValorFiles} />
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label style={{ color: '#FFFFFF' }} htmlFor="upload-files">Subir Archivo(s)</label>
                                                    <button type="submit" className="btn btn-success btn-sm" id='upload-files' name='upload-files'><FontAwesomeIcon icon={faUpload} />&nbsp;&nbsp;Subir Archivo(s)</button>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-12'>
                                                    <div className="progress">
                                                        <div style={{ width: "0%" }} className="progress-bar progress-bar-striped progress-bar-animated" id='progress_files' role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-xl-12 text-center'>
                                                    <div className="btn-group" role="group" aria-label="">
                                                        <Link className="btn btn-danger btn-sm" to={"/MasterCargueOYMRI"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN ARCHIVO CARGADO</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <div id='informacion_cargada'></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;